/**
* @see /client/containers/GiftCardProduct/Booking.js
*/

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from '../../components/Button';
import Input from '../../components/Input';

const StyledQuantity = styled.div`
  display:inline-block;
  width:100%;
  ${Button}{
    background: ${(props) => props.theme.whiteColor};
    border: ${(props) => props.theme.lightGray} solid 1px;
    margin: 0px;
    font-size: 22px;
    padding: 4px 15px;
    float: left;
    font-weight: bold;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      padding: 3px 5px;
    };
    &:hover{
      border:${(props) => props.theme.primaryColor} solid 1px;
      color:${(props) => props.theme.primaryColor};
      background: rgb(237 59 65 / 15%);
      font-weight: bold;
    }
  }
  ${Input}{
    float:left;
    font-weight:bold;
    height:auto;
    width:60px;
    text-align:center;
    padding:10px 20px;
    border:none;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width: 22px;
      padding:0px;
    };
  }
`;

function Quantity(props) {
  const { handleChildActions, quantity, cart = {} } = props;
  return (
    <StyledQuantity>
      <Button onClick={() => handleChildActions('addQuantity', 'dec', cart)}>-</Button>
      <Input value={quantity} onChange={() => handleChildActions()} />
      <Button onClick={() => handleChildActions('addQuantity', 'inc', cart)}>+</Button>
    </StyledQuantity>
  );
}

Quantity.propTypes = {
  handleChildActions: PropTypes.func,
  quantity: PropTypes.number,
  cart: PropTypes.object,
};

Quantity.defaultProps = {
  quantity: 0,
};

export default Quantity;



// WEBPACK FOOTER //
// client/components/Quantity/index.js